<ion-header>
  <ion-toolbar>
    <ion-title>{{'boulder-lists-page.lists' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content (swiperight)="onSwipeRight()" (swipeleft)="onSwipeLeft()">
  <ion-refresher (ionRefresh)="onRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-fab *ngIf="!guestService.isGuest()" horizontal="end" slot="fixed" vertical="bottom">
    <ion-fab-button color="primary" (click)="createNewList()">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <ion-segment *ngIf="!guestService.isGuest()" mode="md" (ionChange)="segmentChanged($event)" [value]="activeSegment"
               color="secondary">
    <ion-segment-button value="private">
      <ion-label>{{"boulder-lists-page.my-lists" | translate}}</ion-label>
    </ion-segment-button>
    <ion-segment-button value="public">
      <ion-label>{{"boulder-lists-page.public-lists" | translate}}</ion-label>
    </ion-segment-button>
  </ion-segment>
  <h1 *ngIf="!isLoading && activeSegment=='private' && numOwnLists===0">{{"boulder-lists-page.empty" | translate}}</h1>
  <loader *ngIf="isLoading"></loader>
  <ion-list>
    <ion-item *ngFor="let list of boulderLists | sortBoulderLists" routerLink="/boulder-list-details/{{list.listId}}"
              routerDirection="forward" [detail]="true" [class]="list.isProjectList ? 'my-projects' : ''">
      <ion-label>
        <ion-text>
          <h3>{{list.name}}</h3>
        </ion-text>
        <ion-text *ngIf="activeSegment=='public'" class="author">
          <p>{{"boulder-lists-page.by" | translate}} {{list.author}}</p>
        </ion-text>
      </ion-label>
      <ion-note slot="end">{{list.boulderIds.length}} {{"boulder-lists-page.boulder" | translate}}</ion-note>
    </ion-item>
  </ion-list>
</ion-content>
